import { NgbDate } from '@ng-bootstrap/ng-bootstrap';

export class BasicDetails {
    name: any;
    description: any;
    studyType: string;
    objective: any;
    createdByName: string;
    startDate: NgbDate;
    endDate: NgbDate;
    parentFolderName: string;
    parentFolderId: number;
}
